import React from 'react';
import styled from '@emotion/styled';
import NonRegisterdAgentAvatarIcon from 'assets/svg/non-registered-agent-avatar.svg';

const Root = styled.div`
  ${({ theme }) => `
    width: 88px;
    height: 88px;
    background: ${theme.colors.neutrals.grey10};
    border-radius: ${theme.borderRadius.round};
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`;

export const NonRegisteredAgentAvatar: React.FC = () => {
  return (
    <Root>
      <NonRegisterdAgentAvatarIcon height={48} width={48} />
    </Root>
  );
};
